import Loader from "../Loader/Loader";

const TokenSaver = () => {
  return <Loader />;
};

export default TokenSaver;
